import styled, {css} from 'styled-components';
import {mobileMedia, BGImageCenter, LIGHT_GRAY3} from '../../../globalVariables/GlobalVariables';
import {givechakImageOld} from '../../../assets/symbols/images/givechakImage';
import {uploadLight} from '../../../assets/symbols/symbols/brandingIcons';
import {sIBImage} from '../../../component/fullEditImage/FullEditImage.css';
import {dFlexBetween} from '../../../globalVariables/GlobalFlex';
import {image as popupImage} from '../../../component/imagePopup/externalImagePopup/ExternalImagePopup.css';

export const whatsappImageTitle=styled.div`
    font-size: 14px;
    font-weight: 500;
    ${mobileMedia}{
        font-size: 14px;
    }
`;

export const wrapTitle = styled.div`
    width: 100%;
    ${dFlexBetween};
    padding: 5px 10px;
`;

export const wrapWhatsappImage = styled.div`
    ${popupImage}{
        background-size: contain !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
    }
`;

export const whatsappImage=styled.div`
    border: 1px solid ${LIGHT_GRAY3};
    border-radius: 10px;
    width: 100%;
    height: 100px;
    position: relative;
    margin-bottom: 20px;
    ${mobileMedia}{
        height: ${p=>p.height};
    }
    ${sIBImage}{
        border: none;
        height: 100%;
    }

`;

export const image=styled.div`
    position: absolute;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    ${p => BGImageCenter(p.image, 'contain')}
    &.givechak {
    ${p => p.image === givechakImageOld && css`
      width: 160px;
      height: 100%;
      background-size: auto;
      ${mobileMedia} {
        background-size: 40%;
      }
    `}
  }
`;

export const uploadIcon=styled.div`
    width: 20px;
    height: 20px;
    ${BGImageCenter(uploadLight, 'contain')}
    position: absolute;
    bottom: 10px;
    inset-inline-end: 10px;
    pointer-events: none;
`;
